import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVDate } from "../../shared/JVDate";
import { useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfQuarter,
    endOfQuarter
} from "date-fns";

export interface IFilter {
    contact?: IDropdown;
    contact_ID?: number;
    fromDate?: Date | string;
    toDate?: Date | string;
    range?: string; // ✅ add this
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [contacts, setContacts] = useState<IDropdown[]>();
    const now = new Date();
    const { control, handleSubmit, reset, watch } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: {
            ...props.filter,
            fromDate: props.filter?.fromDate || startOfMonth(now),
            toDate: props.filter?.toDate || new Date()
        },
        shouldFocusError: false
    });
    const range = watch("range");
    useEffect(() => {
        if (range) {
            let start: Date | undefined;
            let end: Date | undefined;
            const now = new Date();

            switch (range) {
                case "this-week":
                    start = startOfWeek(now);
                    end = endOfWeek(now);
                    break;
                case "this-month":
                    start = startOfMonth(now);
                    end = endOfMonth(now);
                    break;
                case "quarterly":
                    start = startOfQuarter(now);
                    end = endOfQuarter(now);
                    break;
            }

            if (start && end) {
                reset({
                    ...watch(),
                    fromDate: start,
                    toDate: end,
                    range: range
                });
            }
        }
    }, [range]);
    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }

    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        if (data.contact) {
            data.contact_ID = data.contact.id;
        }
        searchToDB(data);
    }




    const Clear = () => {
        reset({
            contact: undefined,
            contact_ID: undefined,
            fromDate: undefined,
            toDate: undefined,
            range: undefined
        });
        props.setFilter({});
    };

    return (
        <Accordion className="mb-2">
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="range">Quick Select</label>
                        <Dropdown
                            id="range"
                            value={range}
                            options={[
                                { label: "This Week", value: "this-week" },
                                { label: "This Month", value: "this-month" },
                                { label: "Quarterly", value: "quarterly" }
                            ]}
                            onChange={(e) => reset({ ...watch(), range: e.value })}
                            placeholder="Select Range"
                            showClear
                        />
                    </div>

                    <JVDate label="From Date" name="fromDate" control={control} column={4} maxDate={new Date()} />
                    <JVDate label="To Date" name="toDate" control={control} column={4} maxDate={new Date()} />
                    <JVDropdownInput column={4} completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" />
                    <div className="col-12 md:col-12 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button style={{ width: '100px', height: '34px' }} loading={props.loading} label="SEARCH" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px', height: '34px' }} label="CLEAR" onClick={Clear} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </AccordionTab>
        </Accordion>
    );
}
